import React, { useEffect, useState } from "react";
// import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, CardTitle, CardSubtitle, Button } from "reactstrap"
// import "./datatables.scss";
import '../Icons/IconFontawesome';

import Utils from '../Utility';
import { put, get } from "../../helpers/api_helper";
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import DataTable from 'react-data-table-component';
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from 'react-toastify';

import TaskCard from './TaskCard';
import styled from '@emotion/styled';
import Modal from './DeleteModal';


const UnassignedLeads = (props) => {
  const { user, role, currentLead, setCurrentLead, setIsAddForm } = props;
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [isModal, setIsModal] = useState(false);
  const [modalData, setModalData] = useState({ type: "Delete" });
  const [leadInAir, setLeadInAir] = useState([]);
  const [moderator, setModerators] = useState([]);
  const [dealer, setDealers] = useState([]);

  console.log('props on card on lead', props);

  useEffect(() => {
    if (user?.companyId) {
      getUsers();
      getLeads();
    }
  }, [user]);

  const getLeads = () => {
    get("/lead/auto/list?kind=assigned&companyId=" + user?.companyId, { token: user?.token })
      .then(json => {
        console.log('response from get lead list', json);
        if (json?.statusCode == 200)
          setData(json?.data);
      })
      .catch(error => {
        console.log('error while getting user list', error);
      })
  };

  const getUsers = async () => {
    get("/dealer/list?companyId=" + user?.companyId, { token: user?.token })
      .then(json => {
        console.log('response from get user list', json);
        if (json.statusCode == 200) {
          setDealers(json?.data);
        }
      })
      .catch(error => {
        console.log('error while getting user list', error);
      });
  }

  // useEffect(() => {
  //   if (data) {
  //     let columns = {}
  //     data.map((item) => {
  //       columns = { ...columns, [item?._id]: { title: item?.name, items: item?.leads } };
  //     });
  //     setColumns(columns);
  //     setTitle(styled.span`
  //     color: #fff;
  //     background: ${props?.user?.company?.theme ? props?.user?.company?.theme : Utils.themeColor};
  //     padding: 2px 10px;
  //     border-radius: 5px;
  //     align-self: flex-start;
  //   `);
  //   }
  // }, [data]);


  useEffect(() => {
    if (data)
      setColumns([
        {
          name: 'Lead Name',
          selector: row => row.name,
        },
        {
          name: 'Client Email',
          selector: row => row.email,
        },
        {
          name: 'Client Mobile',
          selector: row => row.mobile,
        },
        {
          name: 'Description',
          selector: row => row.intro,
        },
        {
          name: 'Project',
          selector: row => row.project.length > 0 ? row.project[0]?.name : ' - ',
        },
        {
          name: 'Status',
          selector: row => row.status,
        },
        {
          cell: (row) => <>
            <AvForm style={{ textAlign: 'left' }}>
              <AvField onChange={(e) => reAssignDealer(row, e.target.value)} style={{ minWidth: 100, padding: 5, paddingLeft: 8, paddingRight: 8 }}
                type="select"
                name="assignToD"
                placeholder={"Select Channel Partner"}
                value={row?.assignToD}
              >
                <option value="">Select Channel Partner</option>
                {dealer.map((item) => {
                  if (item?.projectId == row?.project[0]?._id)
                    return <option key={item?._id} value={item?._id}>{item.name}</option>
                })}
              </AvField>
            </AvForm>
            {/* <Button onClick={() => handleDeleteUser(row)} style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-cancel" style={{ fontSize: 20 }}></span></Button> */}
          </>,
          name: 'Assign To Channel Partner',
          ignoreRowClick: true,
          // allowOverflow: true,
          // button: true,
        },
        {
          cell: (row) => <>
            <Button onClick={() => props?.history.push("/auto/lead/" + row?._id)}
              title={"View"}
              style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-eye" style={{ fontSize: 20 }}></span></Button>
            {user?.role == 'Admin' &&
              <Button onClick={() => handleArchivedLead(row)}
                title={"Archive"}
                style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-archive-arrow-down" style={{ fontSize: 20 }}></span></Button>
            }
            {user?.role == 'Admin' || row?.addedBy == user?._id ?
              <Button onClick={() => handleUpdateLead(row)}
                title={"Edit"}
                style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-pencil" style={{ fontSize: 20 }}></span></Button>
              : null
            }
          </>,
          name: 'Action',
          ignoreRowClick: true,
          // allowOverflow: true,
          // button: true,
        },
      ])
  }, [dealer, moderator]);


  const reAssignLead = (row, moderatorId) => {
    console.log('updating lead', row._id, moderatorId);
    if (moderatorId != "") {
      let moder = moderator.find(x => x._id == moderatorId);
      setModalData({ type: "Assign", lead: row, userName: moder.name, userId: moderatorId });
      setIsModal(true);
    }
  }

  const reAssignDealer = (row, dealerId) => {
    console.log('updating lead', row._id, dealerId);
    if (dealerId != "") {
      let moder = dealer.find(x => x._id == dealerId);
      setModalData({ type: "Assign", subType: 'dealer', lead: row, userName: moder.name, userId: dealerId });
      setIsModal(true);
    }
  }

  const handleArchivedLead = (lead) => {
    console.log('updating lead', lead);
    setModalData({ type: "Archive", lead: lead });
    setIsModal(true);
  }

  const handleUpdateLead = (item) => {
    setCurrentLead(item);
    setIsAddForm(true);
  }

  const onConfirm = () => {
    console.log('lead on confirm', modalData.lead);
    let body = { lead_id: modalData?.lead?._id };
    if (modalData?.type == 'Assign') {
      if (user?.role == 'Admin') {
        body = {
          ...body,
          timeline: [...modalData?.lead?.timeline, { title: 'Assign To Moderator', desc: `Lead Assign to ${modalData?.userName} by ${user?.name}` }],
          assignToM: modalData?.userId,
          token: user?.token
        };
        if (modalData?.subType == 'dealer')
          body = { lead_id: modalData?.lead?._id, timeline: [...modalData?.lead?.timeline, { title: 'Assign To Channel Partner', desc: `Lead Assign to ${modalData?.userName} by ${user?.name}` }], assignToD: modalData?.userId, token: user?.token };
      }
      else if (user?.role == 'Moderator')
        body = { lead_id: modalData?.leadId, timeline: [...modalData?.lead?.timeline, { title: 'Assign To Channel Partner', desc: `Lead Assign to ${modalData?.userName} by ${user?.name}` }], assignToD: modalData?.userId, token: user?.token };
    } else if (modalData?.type == 'Archive') {
      body = { lead_id: modalData?.lead?._id, timeline: [...modalData?.lead?.timeline, { title: 'Archived', desc: `Lead Archived by ${user?.name}.` }], status: 'Archived', token: user?.token };
    }
    console.log('calling on confirm');
    put("/lead/update", body)
      .then(json => {
        console.log('response from update lead', json);
        if (json.statusCode == 200) {
          toast.success("Success");
          getLeads();
          setIsModal(false);
          setModalData({ type: "Delete" });
          props?.setReload(!props?.reload);
        }
      })
      .catch(error => {
        console.error('error while deleting user', error);
      })
  }

  return (
    <React.Fragment>
      <div className="d-flex">
        <Modal
          show={isModal}
          onClick={() => onConfirm()}
          onCloseClick={() => { setIsModal(false) }}
          data={modalData}
        />
        {/* <DragDropContext
          onDragEnd={(result) => onDragEnd(result, columns, setColumns)}
        >
          <Container>
            <TaskColumnStyles>
              {Object.entries(columns).map(([columnId, column], index) => {
                return (
                  <Droppable key={columnId} droppableId={columnId}>
                    {(provided, snapshot) => (
                      <TaskList
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                      >
                        <Title>{column.title}</Title>
                        {column.items.map((item, index) => (
                          <TaskCard key={item} columnId={columnId} item={item} history={props.history} handleArchivedLead={handleArchivedLead} setCurrentLead={setCurrentLead} setIsAddForm={setIsAddForm} user={user} index={index} />
                        ))}
                        {provided.placeholder}
                      </TaskList>
                    )}
                  </Droppable>
                );
              })}
            </TaskColumnStyles>
          </Container>
        </DragDropContext> */}
        <div style={{ width: '100%' }}>
          <DataTable
            columns={columns}
            data={data}
            pagination
            customStyles={{
              headCells: {
                style: {
                  color: 'black',
                  fontWeight: 'bold',
                  fontSize: 15,
                  maxWidth: 80
                },
              },
              cells: {
                style: {
                  maxWidth: 50
                }
              }
            }}
          />
        </div>
      </div>
    </React.Fragment>
  )
}

export default UnassignedLeads;
